const breaks = [0.2, 0.4, 0.6, 0.8]
export const triangle1XY = [0.2, 0.2]
export const triangle2XY = [1.4, 0.2]

// Common calculations
const sqrt3 = Math.sqrt(3)
const halfSqrt3 = sqrt3 / 2
const smallOffset = 0.02
const mediumOffset = 0.04
const largeOffset = 0.05
const baseHeight = sqrt3 * 0.1 + halfSqrt3 * 0.5 + halfSqrt3

export const axisLabels = [
    {
        x: triangle1XY[0] + 1.46,
        y: triangle2XY[1] + baseHeight + smallOffset,
        text: 'Ca + Mg',
        rot: '60',
    },
    {
        x: triangle1XY[0] + 0.75,
        y: triangle2XY[1] + baseHeight + smallOffset,
        text: 'SO4 + Cl',
        rot: '-60',
    },
    {
        x: triangle1XY[0] + 0.75 + largeOffset,
        y: triangle1XY[1] + 0.5 * halfSqrt3 + largeOffset,
        text: 'Na + Ba',
        rot: '60',
    },
    {
        x: triangle2XY[0] + 0.25 - largeOffset, // 0.5/2 = 0.25
        y: triangle2XY[1] + 0.5 * halfSqrt3 + largeOffset,
        text: 'NO3 + F',
        rot: '-60',
    },
    {
        x: triangle1XY[0] + 0.15, // 0.5/2 = 0.25
        y: triangle1XY[1] + 0.5 * halfSqrt3 + mediumOffset,
        text: 'Mg',
        rot: '-60',
    },
    {
        x: triangle2XY[0] + 0.83,
        y: triangle2XY[1] + 0.5 * halfSqrt3 + mediumOffset,
        text: 'SO4',
        rot: '60',
    },
    {
        x: 0.71,
        y: 0.05,
        text: 'Ca',
        rot: '0',
    },
    {
        x: 1.91,
        y: 0.05,
        text: 'Cl',
        rot: '0',
    },
].map(x => ({ ...x, style: { fontSize: 18, fontWeight: 500 } }))

export const tickLabels = [
    //cations
    { x: 0.385, y: 0.15, text: '80', rot: '0' },
    { x: 0.5850000000000001, y: 0.15, text: '60', rot: '0' },
    { x: 0.785, y: 0.15, text: '40', rot: '0' },
    { x: 0.985, y: 0.15, text: '20', rot: '0' },
    { x: 0.58, y: 0.8828203230275509, text: '80', rot: '-60' },
    {
        x: 0.4799999999999999,
        y: 0.7096152422706632,
        text: '60',
        rot: '-60',
    },
    {
        x: 0.37999999999999995,
        y: 0.5364101615137755,
        text: '40',
        rot: '-60',
    },
    {
        x: 0.2799999999999999,
        y: 0.3632050807568877,
        text: '20',
        rot: '-60',
    },
    {
        x: 0.8049999999999999,
        y: 0.9128203230275509,
        text: '20',
        rot: '60',
    },
    {
        x: 0.9049999999999999,
        y: 0.7396152422706632,
        text: '40',
        rot: '60',
    },
    { x: 1.005, y: 0.5664101615137755, text: '60', rot: '60' },
    { x: 1.105, y: 0.3932050807568877, text: '80', rot: '60' },
    // Anions
    { x: 1.585, y: 0.15, text: '20', rot: '0' },
    { x: 1.785, y: 0.15, text: '40', rot: '0' },
    { x: 1.985, y: 0.15, text: '60', rot: '0' },
    { x: 2.185, y: 0.15, text: '80', rot: '0' },
    {
        x: 1.7799999999999998,
        y: 0.8828203230275509,
        text: '20',
        rot: '-60',
    },
    { x: 1.68, y: 0.7096152422706632, text: '40', rot: '-60' },
    {
        x: 1.5799999999999998,
        y: 0.5364101615137755,
        text: '60',
        rot: '-60',
    },
    { x: 1.48, y: 0.3632050807568877, text: '80', rot: '-60' },
    { x: 2.005, y: 0.9128203230275509, text: '80', rot: '60' },
    { x: 2.105, y: 0.7396152422706632, text: '60', rot: '60' },
    {
        x: 2.2049999999999996,
        y: 0.5664101615137755,
        text: '40',
        rot: '60',
    },
    {
        x: 2.3049999999999997,
        y: 0.3932050807568877,
        text: '20',
        rot: '60',
    },
    // Diamond
    { x: 0.882, y: 1.4074355652982142, text: '20', rot: '-60' },
    { x: 0.982, y: 1.580640646055102, text: '40', rot: '-60' },
    { x: 1.082, y: 1.7538457268119896, text: '60', rot: '-60' },
    {
        x: 1.1820000000000002,
        y: 1.9270508075688773,
        text: '80',
        rot: '-60',
    },
    {
        x: 1.7049999999999998,
        y: 1.4324355652982141,
        text: '20',
        rot: '60',
    },
    { x: 1.605, y: 1.6056406460551018, text: '40', rot: '60' },
    { x: 1.505, y: 1.7788457268119895, text: '60', rot: '60' },
    {
        x: 1.4049999999999998,
        y: 1.9520508075688772,
        text: '80',
        rot: '60',
    },
].map(x => ({ ...x, fontSize: 12 }))

export const triangleFilllines = () => {
    const lines = []
    //Triangle 1 horizontal lines
    for (let i in breaks) {
        lines.push({
            x0: triangle1XY[0] + breaks[i] / 2,
            y0: triangle1XY[1] + (breaks[i] * Math.sqrt(3)) / 2,
            x1: triangle1XY[0] + 1 - breaks[i] / 2,
            y1: triangle1XY[1] + (breaks[i] * Math.sqrt(3)) / 2,
        })
    }
    //Triangle 1 left leaning grids
    for (let i in breaks) {
        lines.push({
            x0: triangle1XY[0] + 1 - breaks[i],
            y0: triangle1XY[1],
            x1: triangle1XY[0] + 1 / 2 - breaks[i] / 2,
            y1: triangle1XY[1] + ((1 - breaks[i]) * Math.sqrt(3)) / 2,
        })
    }
    //Triangle 1 right leaning grids
    for (let i in breaks) {
        lines.push({
            x0: triangle1XY[0] + 1 - (1 - breaks[i]),
            y0: triangle1XY[1],
            x1: triangle1XY[0] + 1 / 2 + breaks[i] / 2,
            y1: triangle1XY[1] + ((1 - breaks[i]) * Math.sqrt(3)) / 2,
        })
    }
    //Triangle 2 horizontal lines
    for (let i in breaks) {
        lines.push({
            x0: triangle2XY[0] + breaks[i] / 2,
            y0: triangle2XY[1] + (breaks[i] * Math.sqrt(3)) / 2,
            x1: triangle2XY[0] + 1 - breaks[i] / 2,
            y1: triangle2XY[1] + (breaks[i] * Math.sqrt(3)) / 2,
        })
    }
    //Triangle 2 left leaning grids
    for (let i in breaks) {
        lines.push({
            x0: triangle2XY[0] + 1 - breaks[i],
            y0: triangle2XY[1],
            x1: triangle2XY[0] + 1 / 2 - breaks[i] / 2,
            y1: triangle2XY[1] + ((1 - breaks[i]) * Math.sqrt(3)) / 2,
        })
    }
    //Triangle 2 right leaning grids
    for (let i in breaks) {
        lines.push({
            x0: triangle2XY[0] + 1 - (1 - breaks[i]),
            y0: triangle2XY[1],
            x1: triangle2XY[0] + 1 / 2 + breaks[i] / 2,
            y1: triangle2XY[1] + ((1 - breaks[i]) * Math.sqrt(3)) / 2,
        })
    }
    //Rhombus left leaning grids
    for (let i in breaks) {
        lines.push({
            x0: triangle1XY[0] + 1.1 + breaks[i] / 2,
            y0:
                triangle2XY[1] +
                Math.sqrt(3) * 0.1 +
                (Math.sqrt(3) / 2) * breaks[i],
            x1: triangle1XY[0] + 1.1 - 1 / 2 + breaks[i] / 2,
            y1:
                triangle2XY[1] +
                Math.sqrt(3) * 0.1 +
                (Math.sqrt(3) / 2) * breaks[i] +
                Math.sqrt(3) / 2,
        })
    }
    //Rhombus right leaning grids
    for (let i in breaks) {
        lines.push({
            x0: triangle1XY[0] + 1.1 - breaks[i] / 2,
            y0:
                triangle2XY[1] +
                Math.sqrt(3) * 0.1 +
                (Math.sqrt(3) / 2) * breaks[i],
            x1: triangle1XY[0] + 1.1 + 1 / 2 - breaks[i] / 2,
            y1:
                triangle2XY[1] +
                Math.sqrt(3) * 0.1 +
                (Math.sqrt(3) / 2) * breaks[i] +
                Math.sqrt(3) / 2,
        })
    }

    return lines
}

const triangles = [
    //Triangle 1
    {
        x0: triangle1XY[0],
        y0: triangle1XY[1],
        x1: triangle1XY[0] + 1,
        y1: triangle1XY[1],
    },
    {
        x0: triangle1XY[0] + 1 / 2,
        y0: triangle1XY[1] + Math.sqrt(3) / 2,
        x1: triangle1XY[0] + 1,
        y1: triangle1XY[1],
    },
    {
        x0: triangle1XY[0] + 1 / 2,
        y0: triangle1XY[1] + Math.sqrt(3) / 2,
        x1: triangle1XY[0],
        y1: triangle1XY[1],
    },
    //Triangle 2
    {
        x0: triangle2XY[0],
        y0: triangle2XY[1],
        x1: triangle2XY[0] + 1,
        y1: triangle2XY[1],
    },
    {
        x0: triangle2XY[0] + 1 / 2,
        y0: triangle2XY[1] + Math.sqrt(3) / 2,
        x1: triangle2XY[0] + 1,
        y1: triangle2XY[1],
    },
    {
        x0: triangle2XY[0] + 1 / 2,
        y0: triangle2XY[1] + Math.sqrt(3) / 2,
        x1: triangle2XY[0],
        y1: triangle2XY[1],
    },
    // Combined
    {
        x0: triangle1XY[0] + 1.1,
        y0: triangle2XY[1] + Math.sqrt(3) * 0.1,
        x1: triangle1XY[0] + 1.1 - 1 / 2,
        y1: triangle2XY[1] + Math.sqrt(3) * 0.1 + Math.sqrt(3) / 2,
    },
    {
        x0: triangle1XY[0] + 1.1,
        y0: triangle2XY[1] + Math.sqrt(3) * 0.1,
        x1: triangle1XY[0] + 1.1 + 1 / 2,
        y1: triangle2XY[1] + Math.sqrt(3) * 0.1 + Math.sqrt(3) / 2,
    },
    {
        x0: triangle1XY[0] + 1.1,
        y0: triangle2XY[1] + Math.sqrt(3) * 0.1 + Math.sqrt(3),
        x1: triangle1XY[0] + 1.1 - 1 / 2,
        y1: triangle2XY[1] + Math.sqrt(3) * 0.1 + Math.sqrt(3) / 2,
    },
    {
        x0: triangle1XY[0] + 1.1,
        y0: triangle2XY[1] + Math.sqrt(3) * 0.1 + Math.sqrt(3),
        x1: triangle1XY[0] + 1.1 + 1 / 2,
        y1: triangle2XY[1] + Math.sqrt(3) * 0.1 + Math.sqrt(3) / 2,
    },
]

export default triangles
